"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.has = has;
exports.get = get;
exports.set = set;
exports.remember = remember;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

/**
 * 判断 sessionStorage 是否包含所指定的 key
 *
 * @param {string} key
 * @returns {boolean}
 */
function has(key) {
  if (!sessionStorage[key]) {
    return false;
  }

  try {
    var keys = Object.keys(JSON.parse(sessionStorage[key]));
    return keys.includes('data');
  } catch (e) {
    return false;
  }
}
/**
 * 通过 key 获取 sessionStorage 中存储的值
 *
 * @param {string} key
 * @returns {*}
 */


function get(key) {
  if (!sessionStorage[key]) {
    return undefined;
  }

  try {
    return JSON.parse(sessionStorage[key]).data;
  } catch (e) {
    return undefined;
  }
}
/**
 * 向 sessionStorage 中保存值
 *
 * @param {string} key
 * @param {*} data
 * @returns {*}
 */


function set(key, data) {
  try {
    sessionStorage[key] = JSON.stringify({
      data: data
    });
    return data;
  } catch (e) {
    return data;
  }
}
/**
 * 从 sessionStorage 中取值，如果取不到相应的值，则调用 callable 函数，将返回值保存到 sessionStorage 中
 *
 * @param {string} key
 * @param {function} callable
 * @returns {Promise<*>}
 */


function remember(_x, _x2) {
  return _remember.apply(this, arguments);
}

function _remember() {
  _remember = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key, callable) {
    var data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!has(key)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", get(key));

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return callable();

          case 5:
            data = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            data = undefined;

          case 11:
            set(key, data); // 保存返回值

            return _context.abrupt("return", data);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));
  return _remember.apply(this, arguments);
}